import { render, staticRenderFns } from "./CaDataPresta.vue?vue&type=template&id=00fd1062&"
import script from "./CaDataPresta.vue?vue&type=script&lang=ts&"
export * from "./CaDataPresta.vue?vue&type=script&lang=ts&"
import style0 from "./CaDataPresta.vue?vue&type=style&index=0&id=00fd1062&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports